import PropTypes from 'prop-types';
import { Component } from 'react';
import { getCurrentUserLanguage } from '../selectors/AttributesSelector';
import { getFetchAttributesRequestStatus, getFetchProfileOptionsRequestStatus } from '../selectors/RequestStatusSelector';
import { connect } from 'react-redux';
import LanguageEditor from '../components/LanguageEditor';
import { stageChange, clearChange } from '../actions/StagingActions';
import { LANGUAGE, LOCALE } from '../constants/StagingDataKeys';
import { anyRequestsFailed, allFinished } from '../utils/requestUtils';
import { getIsUngatedBetaLanguages } from '../selectors/LocaleSelector';
import { getLanguagesToDefaultLocales } from '../selectors/ProfileOptionsSelector';
import { MultiColumn, MultiColumnGroup, MultiColumnItem } from 'foundations-components/transitional/components/MultiColumn';
import { jsx as _jsx } from "react/jsx-runtime";
class LanguageContainer extends Component {
  constructor(props) {
    super(props);
    this.handleLanguageChanged = this.handleLanguageChanged.bind(this);
  }
  handleLanguageChanged(language) {
    const {
      langToDefaultLocaleMap
    } = this.props;
    // TODO: Stage locale as well
    if (language !== this.props.language) {
      const defaultLocale = langToDefaultLocaleMap[language];
      this.props.stageChange(LANGUAGE, language);
      this.props.stageChange(LOCALE, defaultLocale);
    } else {
      this.props.clearChange(LANGUAGE);
      this.props.clearChange(LOCALE); // ???
    }
  }
  render() {
    const {
      language,
      fetchAttributesRequestStatus,
      fetchProfileOptionsRequestStatus,
      isUngatedBetaLanguages,
      stagedLanguage
    } = this.props;
    return /*#__PURE__*/_jsx(MultiColumn, {
      flush: true,
      children: /*#__PURE__*/_jsx(MultiColumnGroup, {
        children: /*#__PURE__*/_jsx(MultiColumnItem, {
          children: /*#__PURE__*/_jsx(LanguageEditor, {
            failed: anyRequestsFailed(fetchAttributesRequestStatus, fetchProfileOptionsRequestStatus),
            loadingUserLanguage: !allFinished(fetchAttributesRequestStatus),
            loadingLocaleMapping: !allFinished(fetchProfileOptionsRequestStatus),
            language: stagedLanguage || language,
            handleLanguageChanged: this.handleLanguageChanged,
            isUngatedBetaLanguages: isUngatedBetaLanguages
          })
        })
      })
    });
  }
}
LanguageContainer.propTypes = {
  fetchAttributesRequestStatus: PropTypes.string.isRequired,
  fetchProfileOptionsRequestStatus: PropTypes.string.isRequired,
  isUngatedBetaLanguages: PropTypes.bool.isRequired,
  language: PropTypes.string,
  stagedLanguage: PropTypes.string,
  stageChange: PropTypes.func.isRequired,
  clearChange: PropTypes.func.isRequired,
  langToDefaultLocaleMap: PropTypes.object.isRequired
};
const mapStateToProps = state => {
  return {
    language: getCurrentUserLanguage(state),
    stagedLanguage: state.stagedChanges.get(LANGUAGE),
    fetchAttributesRequestStatus: getFetchAttributesRequestStatus(state),
    fetchProfileOptionsRequestStatus: getFetchProfileOptionsRequestStatus(state),
    isUngatedBetaLanguages: getIsUngatedBetaLanguages(state),
    langToDefaultLocaleMap: getLanguagesToDefaultLocales(state)
  };
};
export default connect(mapStateToProps, {
  stageChange,
  clearChange
})(LanguageContainer);